/* eslint-disable react/jsx-no-undef */
// @ts-nocheck

import { yupResolver } from "@hookform/resolvers/yup";
import MessageFormValidateV2 from "components/Common/MessageFormValidateV2";
import { useCreateOrderGetGoods, useListBus } from "hooks";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { AsyncPaginate } from "react-select-async-paginate";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import * as yup from "yup";
import HubFilterCreateOrder from "./HubFilterCreateOrder/HubFilterCreateOrder";
import NotificationModal from "./NotificationModal";
import busService from "services/busService";
import { CREATE_MODE } from "constants/order";

const initParams = {
  sizePerPage: 30,
  columnFilter: {
    "filter[record_status]": "O",
  },
  expand: "hub",
  page: 1,
  fields: "",
  run: false,
};

const CreateOrderGetGoodsModal = ({
  dataDefaultCreateOrderGetGoodsPopup,
  isLogAdmin,
  createOrderSuccessHandle,
  isOpen,
  toggle,
  isHaveLinkOrderDetail = true,
}) => {
  const { addToast } = useToasts();
  const notificationModalRef = useRef(null);

  const [params, setParams] = useState(initParams);
  const [paramsHub, setParamsHub] = useState(initParams);
  const [createMode, setCreateMode] = useState(CREATE_MODE.WITH_CHILDREN);

  const initDefaultValues = {
    bus_id: null,
  };

  const schema = yup.object().shape({
    bus_id: yup.object().nullable().required("Vui lòng chọn"),
  });

  const mainForm = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = mainForm;

  useEffect(() => {
    if (errors) {
      console.log("🚀 ~ useEffect ~ errors:", errors);
    }
  }, [errors]);

  // Fetch list of buses
  const {
    data: busList,
    refetch: fetchListBus,
    remove: removeListBus,
  } = useListBus({ params }, null, null, "bus-to-create-order");

  const onSuccessCreateOrderGetGoods = responseData => {
    if (responseData?.result) {
      if (responseData?.order?.id) {
        addToast(
          isHaveLinkOrderDetail
            ? "Tạo đơn lấy hàng nhà xe thành công"
            : "Đồng bộ đơn con thành công",
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggle();
        notificationModalRef.current?.open({
          status: "success",
          successData: {
            code: responseData?.order?.order_code,
            id: responseData?.order?.id,
          },
        });
        createOrderSuccessHandle();
      } else {
        addToast("Không có đơn để gom", {
          appearance: "warning",
          autoDismiss: true,
        });
      }
    } else {
      addToast(
        isHaveLinkOrderDetail
          ? "Tạo đơn lấy hàng nhà xe thất bại"
          : "Đồng bộ đơn con thất bại",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (responseData?.message) {
        if (responseData?.message?.timeslot_id) {
          addToast(responseData?.message?.timeslot_id?.[0], {
            appearance: "error",
            autoDismiss: true,
          });
        } else if (responseData?.message?.customer) {
          addToast(responseData?.message?.customer?.[0], {
            appearance: "error",
            autoDismiss: true,
          });
        } else {
          addToast(responseData?.message, {
            appearance: "error",
            autoDismiss: true,
          });
        }
      }
    }
  };

  const {
    isLoading: isLoadingCreateOrderGetGoods,
    mutate: mutateCreateOrderGetGoods,
    data: dataCreateOrderGetGoods,
    reset: resetCreateOrderGetGoods,
  } = useCreateOrderGetGoods(onSuccessCreateOrderGetGoods);

  // A ref to hold the pending promise resolver from loadOptions.
  const pendingPromiseRef = useRef(null);

  // Trigger fetch when params.run is true.
  useEffect(() => {
    if (params.run) {
      fetchListBus();
    }
  }, [params, fetchListBus]);

  // When busList updates, resolve the pending promise (if any).
  useEffect(() => {
    if (pendingPromiseRef.current && busList) {
      const items = busList.items || [];
      const meta = busList.meta || {};

      const options = items.map(i => ({
        value: i.id,
        label: `${i.name} - ${i.phone_number} - ${
          i.address +
          (i.ward_name ? ", " + i.ward_name : "") +
          (i.district_name ? ", " + i.district_name : "") +
          (i.province_name ? ", " + i.province_name : "")
        }`,
      }));

      const hasMore = meta.currentPage < meta.pageCount;
      const { resolve, page } = pendingPromiseRef.current;

      resolve({
        options,
        hasMore,
        additional: { page: page + 1 },
      });

      pendingPromiseRef.current = null;
    }
  }, [busList, pendingPromiseRef.current]);

  useEffect(() => {
    if (isOpen) {
      setCreateMode(CREATE_MODE.WITH_CHILDREN);
    } else {
      removeListBus();
      setParamsHub(initParams);
      resetCreateOrderGetGoods(null);
    }
  }, [isOpen, dataDefaultCreateOrderGetGoodsPopup]);

  useEffect(() => {
    if (dataDefaultCreateOrderGetGoodsPopup) {
      if (dataDefaultCreateOrderGetGoodsPopup?.bus_id) {
        setValue(
          "bus_id",
          { value: dataDefaultCreateOrderGetGoodsPopup?.bus_id },
          { shouldValidate: true }
        );
      } else {
        setValue("bus_id", null, { shouldValidate: true });
      }
      if (dataDefaultCreateOrderGetGoodsPopup?.isCreateAfterOpen) {
        setTimeout(() => {
          handleSubmit(onSubmit)();
        });
      }
    }
  }, [dataDefaultCreateOrderGetGoodsPopup]);

  // Load options for AsyncPaginate - GỌI TRỰC TIẾP SERVICE, KHÔNG DÙNG refetch
  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    try {
      const hubIds = paramsHub?.columnFilter?.["filter[hub_id][in]"] || [];

      const { data } = await busService.listBus({
        params: {
          ...paramsHub,
          page: page || 1,
          sizePerPage: paramsHub?.sizePerPage || 30,
          keywords: searchQuery || "",
          columnFilter: {
            ...(paramsHub?.columnFilter || {}),
            "filter[hub_id][in]": hubIds,
            "filter[record_status]": "O",
          },
          expand: "hub",
          fields: "",
        },
      });

      const items = Array.isArray(data?.items)
        ? data.items
        : Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data)
        ? data
        : [];

      const seen = new Set();
      const unique = items.filter(i => {
        if (!i?.id || seen.has(i.id)) return false;
        seen.add(i.id);
        return true;
      });

      const rawMeta = data?.meta || data?._meta || data?.pagination || {};
      const currentPage =
        rawMeta?.currentPage ??
        rawMeta?.current_page ??
        rawMeta?.page ??
        (page || 1);
      const pageCount =
        rawMeta?.pageCount ?? rawMeta?.total_pages ?? rawMeta?.last_page ?? 1;

      return {
        options: unique.map(i => ({
          value: i.id,
          label: `${i.name || ""} - ${i.phone_number || ""} - ${
            (i.address || "") +
            (i.ward_name ? ", " + i.ward_name : "") +
            (i.district_name ? ", " + i.district_name : "") +
            (i.province_name ? ", " + i.province_name : "")
          }`,
        })),
        hasMore: Number(currentPage) < Number(pageCount),
        additional: { page: (Number(currentPage) || 1) + 1 },
      };
    } catch (error) {
      console.error("❌ Load bus options error:", error);
      return { options: [], hasMore: false, additional: { page } };
    }
  };
  // Handle hub filter change
  const handleHubChange = () => {
    removeListBus(); // Clear existing bus list
    setValue("bus_id", null, { shouldValidate: true }); // Reset selected value
  };

  const handleToggleModal = () => {
    toggle();
  };

  const onSubmit = values => {
    if (dataDefaultCreateOrderGetGoodsPopup?.order) {
      if (dataDefaultCreateOrderGetGoodsPopup?.order?.is_receive_bus == 0) {
        // Tạo đơn lấy hàng nhà xe từ đơn con cụ thể
        mutateCreateOrderGetGoods({
          bus_id: values?.bus_id?.value,
          create_mode: createMode,
          order_ids: dataDefaultCreateOrderGetGoodsPopup?.order?.id
            ? [dataDefaultCreateOrderGetGoodsPopup?.order?.id]
            : undefined,
        });
      } else {
        // Đồng bộ đơn con
        mutateCreateOrderGetGoods({
          bus_id: values?.bus_id?.value,
          create_mode: createMode,
        });
      }
    } else {
      // Tạo đơn lấy hàng nhà xe từ nhà xe
      mutateCreateOrderGetGoods({
        bus_id: values?.bus_id?.value,
        create_mode: createMode,
      });
    }
  };

  return (
    <>
      <Modal
        size="lg"
        role="dialog"
        autoFocus={true}
        centered={true}
        isOpen={
          isOpen &&
          dataDefaultCreateOrderGetGoodsPopup?.isCreateAfterOpen === false
        }
        toggle={handleToggleModal}
      >
        <ModalHeader toggle={handleToggleModal}>
          {dataDefaultCreateOrderGetGoodsPopup?.order?.is_receive_bus == 1
            ? "Đồng bộ đơn con"
            : "Tạo đơn lấy hàng nhà xe"}
        </ModalHeader>
        <ModalBody>
          <div>
            {!dataDefaultCreateOrderGetGoodsPopup?.order ? (
              <>
                <div className="d-flex align-items-end gap-3 mb-2">
                  <div className="flex-grow-1" style={{ maxWidth: "50%" }}>
                    <HubFilterCreateOrder
                      defaultHubSelect={
                        dataDefaultCreateOrderGetGoodsPopup?.hub
                      }
                      queryKey={"Hub-bus"}
                      label={"Hub"}
                      mainFilterParams={paramsHub}
                      setMainFilterParams={setParamsHub}
                      handleChangeHub={handleHubChange}
                      isNotFilterChildHub={true}
                      isHaveAllOption={isLogAdmin}
                      isFilterAllDefault={true}
                      isShowBothOldAndNew={true}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center"
                    style={{ paddingBottom: "8px" }}
                  >
                    <input
                      type="checkbox"
                      id="create_mode_checkbox"
                      checked={createMode === CREATE_MODE.WITHOUT_CHILDREN}
                      onChange={e => {
                        setCreateMode(
                          e.target.checked
                            ? CREATE_MODE.WITHOUT_CHILDREN
                            : CREATE_MODE.WITH_CHILDREN
                        );
                      }}
                      style={{ marginRight: "8px", cursor: "pointer" }}
                    />
                    <Label
                      htmlFor="create_mode_checkbox"
                      style={{ margin: 0, cursor: "pointer" }}
                    >
                      Tạo đơn không có đơn con
                    </Label>
                  </div>
                </div>
                <Label htmlFor="collector_id_current">
                  Danh sách chành/ nhà xe:
                </Label>
                <Controller
                  control={control}
                  name="bus_id"
                  render={({ field }) => (
                    <AsyncPaginate
                      {...field}
                      key={`${JSON.stringify(paramsHub?.columnFilter)}`}
                      isClearable
                      debounceTimeout={500}
                      placeholder="Chọn chành/ nhà xe"
                      loadOptions={loadOptions}
                      defaultOptions
                      additional={{ page: 1 }}
                      onChange={value => {
                        if (value && value.length > 10) {
                          addToast("Đã đủ 10 KH", {
                            appearance: "warning",
                            autoDismiss: true,
                          });
                          return;
                        }
                        field.onChange(value);
                      }}
                    />
                  )}
                />
                <MessageFormValidateV2 errors={errors} fieldName={"bus_id"} />
              </>
            ) : (
              <>
                <h5 htmlFor="collector_id_current" className="mt-2">
                  {dataDefaultCreateOrderGetGoodsPopup?.order?.is_receive_bus ==
                  1 ? (
                    <>
                      Đơn lấy hàng nhà xe{" "}
                      <span className="text-info fw-bold">
                        {dataDefaultCreateOrderGetGoodsPopup?.order?.order_code}
                      </span>{" "}
                      sẽ thực hiện đồng bộ lại đơn con
                    </>
                  ) : (
                    <>
                      Đơn{" "}
                      <span className="text-info fw-bold">
                        {dataDefaultCreateOrderGetGoodsPopup?.order?.order_code}
                      </span>{" "}
                      sẽ gom vào đơn lấy hàng nhà xe phù hợp
                    </>
                  )}
                </h5>
                {/* <div>
                <div className="d-flex gap-2">
                  <div className="fw-bold">Mã đơn:</div>
                  <div className="fw-bold text-info">
                    {dataDefaultCreateOrderGetGoodsPopup?.order?.order_code}
                  </div>
                </div>
                {dataDefaultCreateOrderGetGoodsPopup?.order?.ref_code && (
                  <div className="d-flex gap-2">
                    <div>Mã tham chiếu:</div>{" "}
                    <div className="fw-bold text-info">
                      {dataDefaultCreateOrderGetGoodsPopup?.order?.ref_code}
                    </div>
                  </div>
                )}
              </div> */}
              </>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex gap-2">
            <Button onClick={toggle}>Đóng</Button>
            <Button
              color="primary"
              className="btn-label"
              type="button"
              disabled={isLoadingCreateOrderGetGoods}
              onClick={() => {
                handleSubmit(onSubmit)();
              }}
            >
              <i className="bx bx-save label-icon"></i>
              {dataDefaultCreateOrderGetGoodsPopup?.order?.is_receive_bus == 1
                ? "Xác nhận đồng bộ"
                : "Xác nhận tạo"}
            </Button>
          </div>
        </ModalFooter>
      </Modal>

      <Modal
        size="lg"
        role="dialog"
        autoFocus={true}
        centered={true}
        isOpen={isLoadingCreateOrderGetGoods}
      >
        <ModalHeader>
          <div className="d-flex gap-2 align-items-center">
            {" "}
            <Spinner color="primary" />
            {dataDefaultCreateOrderGetGoodsPopup?.order?.is_receive_bus == 1
              ? "Đang Đồng bộ đơn con"
              : "Đang tạo đơn lấy hàng nhà xe"}
          </div>
        </ModalHeader>
      </Modal>
      <NotificationModal
        ref={notificationModalRef}
        isHaveLinkOrderDetail={isHaveLinkOrderDetail}
      />
    </>
  );
};

export default CreateOrderGetGoodsModal;
